function getUserLabel(user) {
  return user.displayName ?? user.id;
}
function formatMessageTimestamp(dateTime) {
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) {
    return dateTime;
  }
  return d.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit'
  });
}
function formatConversationTimestamp(dateTime) {
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) {
    return dateTime;
  }
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const messageDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((today.getTime() - messageDay.getTime()) / 86400000);
  if (diffDays === 0) {
    return d.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric'
  });
}
const messageStatusLabels = {
  pending: 'Pending',
  sending: 'Sending',
  streaming: 'Streaming',
  sent: 'Sent',
  read: 'Read',
  error: 'Error',
  cancelled: 'Cancelled'
};
const toolStateLabels = {
  'input-streaming': 'Running…',
  'input-available': 'Running…',
  'approval-requested': 'Awaiting approval',
  'approval-responded': 'Running…',
  'output-available': 'Completed',
  'output-error': 'Failed',
  'output-denied': 'Denied'
};
export const CHAT_DEFAULT_LOCALE_TEXT = {
  composerInputPlaceholder: 'Type a message',
  composerInputAriaLabel: 'Message',
  composerSendButtonLabel: 'Send message',
  composerAttachButtonLabel: 'Add attachment',
  composerAttachInputLabel: 'Upload file',
  messageCopyButtonLabel: 'Copy',
  messageCopyCodeButtonLabel: 'Copy code',
  messageCopiedCodeButtonLabel: 'Copied',
  messageEditedLabel: 'Edited',
  messageDeletedLabel: 'Deleted',
  messageReasoningLabel: 'Reasoning',
  messageReasoningStreamingLabel: 'Thinking…',
  messageToolInputLabel: 'Tool called',
  messageToolOutputLabel: 'Tool result',
  messageToolApproveButtonLabel: 'Approve',
  messageToolDenyButtonLabel: 'Deny',
  conversationListNoConversationsLabel: 'No conversations',
  conversationListSearchPlaceholder: 'Search conversations',
  unreadMarkerLabel: 'New messages',
  retryButtonLabel: 'Retry',
  reconnectButtonLabel: 'Reconnect',
  scrollToBottomLabel: 'Scroll to bottom',
  threadNoMessagesLabel: 'No messages yet',
  threadNoMessagesHelperText: 'Type a message to get started',
  genericErrorLabel: 'Something went wrong',
  loadingLabel: 'Loading…',
  messageStatusLabel: status => messageStatusLabels[status],
  toolStateLabel: state => toolStateLabels[state],
  messageTimestampLabel: dateTime => formatMessageTimestamp(dateTime),
  conversationTimestampLabel: dateTime => formatConversationTimestamp(dateTime),
  typingIndicatorLabel: users => {
    const names = users.map(getUserLabel).join(', ');
    if (users.length === 1) {
      return `${names} is typing`;
    }
    return `${names} are typing`;
  },
  scrollToBottomWithCountLabel: unseenCount => `Scroll to bottom, ${unseenCount} new messages`,
  suggestionsLabel: 'Suggested prompts',
  messageListLabel: 'Message log',
  messageLabel: 'Message',
  conversationHeaderMenuLabel: 'Open conversations',
  conversationHeaderBackLabel: 'Back to conversations',
  conversationHeaderCloseLabel: 'Close conversations',
  conversationHeaderNewChatLabel: 'New chat',
  conversationHeaderSettingsLabel: 'Settings',
  messageAuthorUserLabel: 'User',
  messageAuthorAssistantLabel: 'Assistant',
  messageAuthorSystemLabel: 'System'
};